import routerOptions0 from "/app/node_modules/.pnpm/nuxt@4.0.3_@parcel+watcher@2.5.1_@types+node@22.13.16_@vue+compiler-sfc@3.5.20_db0@0.3._72b551815f03e796a35b7f031d16d25c/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  strict: true,
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}